<script setup lang="ts">
import RFlexColumn from '~/components/r/Flex/RFlexColumn.vue'
import RFlexRow from '~/components/r/Flex/RFlexRow.vue'

const colors = useColor()
const { data: user, refresh, premiumExpiredAt } = useAuth()
const maxExp = computed(
  () =>
    levelSection.find(
      (item) => item.level_id === (user.value?.user.level_id || 0) + 1
    )?.experience || 1
)
const percentage = computed(() => {
  return Number((((user.value?.user.exp || 0) / maxExp.value) * 100).toFixed(2))
})

const levelSection = [
  {
    id: 10,
    experience: 50000,
    level_id: 10,
    badges_id: 10
  },
  {
    id: 9,
    experience: 16000,
    level_id: 9,
    badges_id: 9
  },
  {
    id: 8,
    experience: 7500,
    level_id: 8,
    badges_id: 8
  },
  {
    id: 7,
    experience: 4000,
    level_id: 7,
    badges_id: 7
  },
  {
    id: 6,
    experience: 1800,
    level_id: 6,
    badges_id: 6
  },
  {
    id: 5,
    experience: 900,
    level_id: 5,
    badges_id: 5
  },
  {
    id: 4,
    experience: 500,
    level_id: 4,
    badges_id: 4
  },
  {
    id: 3,
    experience: 200,
    level_id: 3,
    badges_id: 3
  },
  {
    id: 2,
    experience: 50,
    level_id: 2,
    badges_id: 2
  },
  {
    id: 1,
    experience: 1,
    level_id: 1,
    badges_id: 1
  }
]

const openUserCenter = (path = '') => {
  window.open(`/member/${user.value?.user.id}${path}`, '_blank')
}

const openPremium = () => {
  window.open(`/member/${user.value?.user.id}/premium`, '_blank')
}

const logout = async () => {
  await requestSignOut()
  await refresh()
}
</script>

<template>
  <RFlexColumn class="user-card" :gap="12">
    <RFlexRow :gap="12">
      <UserAvatar
        size="md"
        :src="user.user.avatar"
        :auth="user.user.user_auth"
        class="avatar"
        @click="openUserCenter()"
      ></UserAvatar>
      <RFlexExpanded>
        <RFlexColumn align="flex-start" justify="center" :gap="4">
          <RFlexRow :gap="4">
            <RText
              size="lg"
              bold
              class="username"
              :style="{ color: namecolorMap[user.user.name_color] ?? null }"
              @click="openUserCenter()"
            >
              {{ user.user.name }}
            </RText>
            <MBadge :badges="[user.user.level_badge, ...user.user.badges]" />
          </RFlexRow>
          <n-progress
            type="line"
            :height="4"
            :color="colors.primary"
            :border-radius="0"
            :percentage="percentage"
            :show-indicator="false"
          />
          <RFlexRow fill-main-axis>
            <RText type="medium" size="sm">UID:{{ user.user.id }}</RText>
            <RFlexSpacer />
            <RText type="medium" size="sm"
              >{{ user.user.exp }}/{{ maxExp }}
            </RText>
          </RFlexRow>
        </RFlexColumn>
      </RFlexExpanded>
    </RFlexRow>
    <NDivider v-if="premiumExpiredAt" />
    <RFlexRow
      v-if="premiumExpiredAt"
      class="bottom premium"
      justify="flex-start"
      align="center"
      :gap="20"
      @click="openPremium()"
    >
      <MBadge :badges="[20]" />
      <RFlexExpanded>
        <RText>会员到期时间</RText>
      </RFlexExpanded>
      <RText>{{ pipe.exactDate(premiumExpiredAt) }}</RText>
    </RFlexRow>
    <NDivider />
    <RFlexRow class="myz-p-h-8" justify="space-between">
      <RFlexColumn
        class="count"
        align="center"
        @click="openUserCenter('/fans')"
      >
        <RText bold>{{ user.user.follow.fans }}</RText>
        <RText type="medium">粉丝</RText>
      </RFlexColumn>
      <RFlexColumn
        class="count"
        align="center"
        @click="openUserCenter('/follow')"
      >
        <RText bold>{{ user.user.follow.follow }}</RText>
        <RText type="medium">关注</RText>
      </RFlexColumn>
      <RFlexColumn class="count" align="center">
        <RText bold>{{ user.user.neko_coin }}</RText>
        <RText type="medium">喵币</RText>
      </RFlexColumn>
    </RFlexRow>
    <NDivider />
    <RFlexRow
      class="bottom"
      justify="flex-start"
      align="center"
      :gap="20"
      @click="openUserCenter()"
    >
      <div class="i-lucide:user-round myz-text--lg"></div>
      <RFlexExpanded>
        <RText>个人中心</RText>
      </RFlexExpanded>
      <div class="i-lucide:chevron-right w-1em h-1em"></div>
    </RFlexRow>
    <RFlexRow
      class="bottom"
      justify="flex-start"
      align="center"
      :gap="20"
      @click="logout"
    >
      <div class="i-lucide:log-out w-1em h-1em"></div>

      <RFlexExpanded>
        <RText>退出登录</RText>
      </RFlexExpanded>
      <div class="i-lucide:chevron-right w-1em h-1em"></div>
    </RFlexRow>
  </RFlexColumn>
</template>

<style scoped lang="scss">
.user-card {
  width: 270px;
  padding: 12px 6px 16px 6px;
}

.bottom {
  padding: 8px 8px;
  //background-color: var(--color-gray-200);
  margin: 2px -8px !important;
  border-radius: 6px;
  cursor: pointer;

  &:hover {
    background-color: var(--color-gray-200);
  }
  &.premium {
    background-color: var(--color-red-100);
    color: white;
  }
}

.count {
  cursor: pointer;

  &:hover * {
    color: var(--color-primary);
  }
}

.username,
.avatar {
  cursor: pointer;
}
</style>
